import React, { useState } from "react";
import AdminHOC from "../../../components/shared/HOC/AdminHOC";
import CustomLabelDropdown from "../../../components/shared/new Form/Fields/CustomLabelDropdown";
import CustomButton from "../../../components/global/Button/CustomButton";
import EnrollmenrCardsSection from "./components/EnrollmenrCardsSection";
import AddEnrollmentModal from "./components/AddEnrollmentModal";
import CommonTable from "../../../components/shared/table/Table";
import CustomTab from "../../../components/shared/tab/TabComponent";
import { useEnrollmentTablaData } from "../../../hooks/EnrollmentsHook/useEnrollmentTableData";
import CustomInput from "../../../components/global/CustomInput/CustomInput";
import { DatePicker, Progress } from "antd";
import { useEnrollmentFilter } from "../../../hooks/EnrollmentsHook/useEnrollmentsFilters";
import { formatDate } from "../../../utility/formatDate";
import {
  ArrowsAltOutlined,
  VerticalAlignMiddleOutlined,
} from "@ant-design/icons";
import PageLoader from "../../../components/global/Loader/PageLoader";
const { RangePicker } = DatePicker;

const userColumns = [
  { title: "Name", dataIndex: "name" },
  { title: "Total Courses", dataIndex: "totalCourses", width: "30%" },
  {
    title: "Avg Completion",
    dataIndex: "averageCompletion",
    width: "30%",
    render: (val) => (
      <div className="flex items-center gap-2">
        <Progress
          percent={val.toFixed(1)}
          size="small"
          strokeColor="#E74860"
          style={{ flex: 1 }}
        />
      </div>
    ),
  },
  {
    title: "Upcoming Deadlines",
    dataIndex: "upcomingDeadlines",
    width: "8%",
    render: (val) => <div className="flex justify-start">{val}</div>,
  },
];

const courseColumns = [
  { title: "Course", dataIndex: "title" },
  {
    title: "Progress",
    dataIndex: "progress",
    width:"30%",
    render: (val) => (
      <div className="flex items-center gap-2">
        <Progress
          percent={val}
          strokeColor="#E74860"
          size="small"
          style={{ flex: 1 }}
        />
      </div>
    ),
  },
  {
    title: "Deadline",
    dataIndex: "deadline",
    width:"8%",
    render: (val) => formatDate(val, "MMM DD, YYYY"),
  },
];

const bundleColumns = [
  { title: "Bundle", dataIndex: "title" },
  {
    title: "Progress",
    dataIndex: "progress",
    render: (val) => (
      <div className="flex items-center gap-2">
        <Progress
          percent={val}
          strokeColor="#E74860"
          size="small"
          style={{ flex: 1 }}
        />
      </div>
    ),
  },
  {
    title: "Deadline",
    dataIndex: "deadline",
    width:"8%",
    render: (val) => formatDate(val, "MMM DD, YYYY"),
  },
];

const renderBundleCourses = (bundle) => (
  <CommonTable
    data={bundle.enrolledCoursesList}
    columns={courseColumns}
    pagination={false}
    className="nested-table"
  />
);

const renderBundles = (record) => (
  <CommonTable
    data={record.enrolledBundlesList}
    columns={bundleColumns}
    pagination={false}
    className="nested-table"
    expandable={{
      expandedRowRender: renderBundleCourses,
      rowExpandable: (bundle) => bundle.enrolledCoursesList?.length > 0,
      expandIcon: ({ expanded, onExpand, record }) =>
        expanded ? (
          <VerticalAlignMiddleOutlined
            onClick={(e) => onExpand(record, e)}
            style={{ color: "#E74860", fontSize: "14px" }}
          />
        ) : (
          <ArrowsAltOutlined
            onClick={(e) => onExpand(record, e)}
            style={{ color: "#E74860", fontSize: "14px" }}
          />
        ),
    }}
  />
);

const Enrollments = () => {
  const [addEnrollmentVisible, setAddEnrollmentVIsible] = useState(false);
  const [userName, setUserName] = useState();
  const [groupName, setGroupName] = useState();
  const [viewType, setViewType] = useState("users");
  const [courseTitle, setCourseTitle] = useState();
  const [bundleName, setBundleName] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEnddate] = useState();
  const [search, setSearch] = useState();
  const [loader , setLoader] = useState(false);

  const options = [
    { label: "Users", value: "users" },
    { label: "Groups", value: "groups" },
  ];

  const { data, loading, paginationConfig, handlePageChange } =
    useEnrollmentTablaData(
      viewType,
      userName,
      groupName,
      courseTitle,
      bundleName,
      startDate,
      endDate,
      search,
    );

  const {
    bundleOptions,
    courseOptions,
    userOptions,
    groupOptions,
    filterLoading,
  } = useEnrollmentFilter();

  const renderUserExpand = (record) => {
    const hasCourses = record.enrolledCoursesList?.length > 0;
    const hasBundles = record.enrolledBundlesList?.length > 0;

    if (hasCourses && !hasBundles) {
      return (
        <CommonTable
          data={record.enrolledCoursesList}
          columns={courseColumns}
          pagination={false}
          className="nested-table"
        />
      );
    }

    if (!hasCourses && hasBundles) {
      return renderBundles(record);
    }

    const tabEntries = [
      {
        key: "courses",
        label: `Courses (${record.enrolledCoursesList.length})`,
        children: (
          <CommonTable
            data={record.enrolledCoursesList}
            columns={courseColumns}
            pagination={false}
            className="nested-table"
          />
        ),
      },
      {
        key: "bundles",
        label: `Bundles (${record.enrolledBundlesList.length})`,
        children: renderBundles(record),
      },
    ];

    return <CustomTab entries={tabEntries} />;
  };

  return (
    <>
    <PageLoader visible={loader} />
    <div className="p-6 flex flex-col   border border-[#E8E8E8] rounded-[10px] shadow-[0px_0px_6px_0px_rgba(0,0,0,0.05)] gap-6">
      <div className="flex justify-between items-center">
        <p className="text-[#E74860] text-[1.75rem] font-normal">Enrollments</p>
        <div className="flex gap-4">
          <CustomLabelDropdown
            controlId="type"
            controlName="type"
            value={viewType}
            options={options}
            allowClear={false}
            handleSelectChange={(val) => setViewType(val)}
          />
          <CustomButton onClick={() => setAddEnrollmentVIsible(true)}>
            Add Enrollment
          </CustomButton>
        </div>
      </div>
      <EnrollmenrCardsSection />

      <div className="flex gap-4 w-full">
        <div className="flex-1 ">
          <CustomInput
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search Users"
          />
        </div>

        <div className="flex-1 ">
          <CustomLabelDropdown
            options={userOptions}
            placeholder="Filter by User"
            onChange={(val) => setUserName(val)}
            allowClear={true}
            
          />
        </div>

        <div className="flex-1 ">
          <CustomLabelDropdown
            options={courseOptions}
            placeholder="Filter by Course"
            onChange={(val) => setCourseTitle(val)}
            allowClear={true}
            
          />
        </div>

        <div className="flex-1 ">
          <CustomLabelDropdown
            options={bundleOptions}
            placeholder="Filter by Bundle"
            onChange={(val) => setBundleName(val)}
            allowClear={true}
         
            
          />
        </div>
        <div className="flex-1 ">
          <CustomLabelDropdown
            options={groupOptions}
            placeholder="Filter by Group"
            onChange={(val) => setGroupName(val)}
            allowClear={true}
          
          />
        </div>
        <div className="flex-1">
          <RangePicker
            className="w-full h-[46px] hover:!border-red-500 focus:!border-red-500 !rounded-[10px]"
            onChange={(dates) => {
              setStartDate(dates?.[0]?.format("YYYY-MM-DD"));
              setEnddate(dates?.[1]?.format("YYYY-MM-DD"));
            }}
          />
        </div>
      </div>
      <CommonTable
        columns={userColumns}
        rowKey="id"
        data={data || []}
        loading={loading}
        showLoader={loading}
        pagination={paginationConfig}
        onChange={handlePageChange}
        expandable={{
          expandedRowRender: renderUserExpand,
          rowExpandable: (record) =>
            record.enrolledCoursesList?.length > 0 ||
            record.enrolledBundlesList?.length > 0,
          expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <VerticalAlignMiddleOutlined
                onClick={(e) => onExpand(record, e)}
                style={{ color: "#E74860", fontSize: "14px" }}
              />
            ) : (
              <ArrowsAltOutlined
                onClick={(e) => onExpand(record, e)}
                style={{ color: "#E74860", fontSize: "14px" }}
              />
            ),
        }}
      />

      <AddEnrollmentModal
        visible={addEnrollmentVisible}
        onClose={() => setAddEnrollmentVIsible(false)}
        setLoading={setLoader}
      />
    </div>
    </>
  );
};

export default AdminHOC(Enrollments);
